import { z } from 'zod';

export const createSandboxSchema = z.object({
    game_code: z.string().min(1, { message: 'Game code is required' }),
    code: z.string().min(1, { message: 'Code is required' }),
    name: z.string().min(1, { message: 'Name is required' }),
    description: z.string().min(1, { message: 'Description is required' }),
    is_active: z.boolean(),
});

export type CreateSandbox = z.infer<typeof createSandboxSchema>;
